import { useEffect, useState } from "react";
import { NavBar } from "@/components/NavBar";
import { api, fmt } from "@/lib/api";
import { Trophy, Lock } from "lucide-react";

export default function Achievements() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/me/achievements").then(({ data }) => setList(data));
  }, []);

  return (
    <div className="min-h-screen">
      <NavBar />
      <main className="mx-auto max-w-7xl px-6 py-12" data-testid="achievements-page">
        <h1 className="text-4xl font-bold">Achievements</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          {list.filter((a) => a.unlocked).length} of {list.length} unlocked
        </p>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {list.map((a) => (
            <div
              key={a.id}
              data-testid={`achievement-${a.id}`}
              className={`card-hover border p-6 ${
                a.unlocked ? "border-primary/50 bg-primary/5" : "border-border bg-card"
              }`}
            >
              <div className="flex items-center justify-between">
                {a.unlocked ? <Trophy className="h-6 w-6 text-primary" /> : <Lock className="h-5 w-5 text-muted-foreground" />}
                <span className="mono text-xs text-muted-foreground">+{fmt(a.bonus_points)} pts</span>
              </div>
              <h3 className="mt-5 text-lg font-semibold">{a.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{a.description}</p>
              <div className="mt-5 h-1.5 w-full bg-secondary">
                <div
                  className={`h-1.5 transition-[width] duration-700 ${a.unlocked ? "bg-primary" : "bg-accent/60"}`}
                  style={{ width: `${a.progress}%` }}
                />
              </div>
              <div className="mono mt-2 text-xs text-muted-foreground">
                {fmt(a.current)} / {fmt(a.threshold)} {a.metric.replace("_", " ")}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
